import ActionButton, { type ActionButtonProps } from '@/components/ActionButton'
import DropdownMenu, { DropdownMenuProps } from '@/components/DropdownMenu/DropdownMenu'
import { css } from '@emotion/react'
import { MoreIcon } from '@ruguoapp/jike-fe-icons'

export interface MoreMenuButtonProps extends Omit<DropdownMenuProps, 'renderTrigger'> {}

export default function MoreMenuButton({ ...props }: MoreMenuButtonProps) {
	return (
		<DropdownMenu
			position="top-end"
			renderTrigger={(props) => (
				<ActionButton
					icon={
						<MoreIcon
							width="20px"
							height="20px"
							css={css`
								transition: color 0.2s;
							`}
						/>
					}
					{...(props as ActionButtonProps)}
				/>
			)}
			{...props}
		/>
	)
}
